module.exports = __webpack_public_path__ + "img/ivywayfacebook_QR.b50fd853.webp";